export function configurarVistasTimeline(scheduler, sections) {
  // Vista Timeline DÍA (24 horas)
  scheduler.createTimelineView({
    name: 'timeline_day',
    x_unit: 'hour',
    x_step: 1,
    x_date: '%H:%i',
    x_size: 24,
    x_start: 0,
    x_length: 48, // permite scroll a más horas
    column_width: 50,
    y_property: 'section_id',
    y_unit: sections,
    render: 'bar',
    section_autoheight: false,
    dy: 32,
  })

  // Vista Timeline SEMANA
  scheduler.createTimelineView({
    name: 'timeline_week',
    x_unit: 'day',
    x_step: 1,
    x_date: '%D %d',
    x_size: 7,
    x_start: 0,
    x_length: 14, // permite scroll a 14 días
    second_scale: { unit: 'hour', step: 6, template: '%H:%i' },
    column_width: 120,
    y_property: 'section_id',
    y_unit: sections,
    render: 'bar',
    section_autoheight: false,
    dy: 32,
  })

  // Vista Timeline 2 Semanas
  scheduler.createTimelineView({
    name: 'timeline_twoWeeks',
    x_unit: 'day',
    x_step: 1,
    x_date: '%D %d',
    x_size: 14,
    x_start: 0,
    x_length: 28,
    second_scale: { unit: 'hour', step: 12, template: '%H:%i' },
    column_width: 60,
    y_property: 'section_id',
    y_unit: sections,
    render: 'bar',
    section_autoheight: false,
    dy: 32,
  })

  // Vista Timeline Mensual
  scheduler.createTimelineView({
    name: 'timeline_month',
    x_unit: 'day',
    x_step: 1,
    x_date: '%d',
    x_size: 31,
    x_start: 0,
    x_length: 62,
    column_width: 35,
    y_property: 'section_id',
    y_unit: sections,
    render: 'bar',
    section_autoheight: false,
    dy: 32,
  })

  // Header
  scheduler.config.header = [
    'timeline_day',
    'timeline_week',
    'timeline_twoWeeks',
    'timeline_month',
    'date',
    'prev',
    'today',
    'next',
  ]

  // Config horas
  scheduler.config.hour_size_px = 44 // Altura de cada hora en la escala
  scheduler.config.hour_date = '%H:%i' // Formato para mostrar horas en tooltips
  scheduler.config.time_step = 10 // Intervalo de tiempo en minutos
}

export function configurarNavegacion(scheduler) {
  //Navegación: Prev/Next mueve exactamente 7 dias en vista semanal
  scheduler.date.add_timeline_week = function (date, inc) {
    return scheduler.date.add(date, 7 * inc, 'day')
  }

  // Para vista de dia: mueve 1 dia
  scheduler.date.add_timeline_day = function (date, inc) {
    return scheduler.date.add(date, 1 * inc, 'day')
  }

  // Para vista de 2 semanas
  scheduler.date.add_timeline_twoWeeks = function (date, inc) {
    return scheduler.date.add(date, 14 * inc, 'day')
  }

  // Para vista de mes
  scheduler.date.add_timeline_month = function (date, inc) {
    return scheduler.date.add(date, 1 * inc, 'month')
  }
}

export function configurarLabels(scheduler) {
  // Labels en español
  scheduler.locale.labels.timeline_day_tab = 'Horas'
  scheduler.locale.labels.timeline_week_tab = 'Semana'
  scheduler.locale.labels.timeline_twoWeeks_tab = '2 Semanas'
  scheduler.locale.labels.timeline_month_tab = 'Mes'
  scheduler.locale.labels.dhx_cal_today_button = 'Hoy'
  scheduler.locale.labels.dhx_cal_prev_button = '◀'
  scheduler.locale.labels.dhx_cal_next_button = '▶'
}

export function configurarTemplates(scheduler) {
  // Header de columna de máquinas (eje Y)
  scheduler.templates.timeline_scaley_header = function (date1, date2) {
    return '<div style="line-height:42px;font-weight:600;padding:0 8px">Máquinas</div>'
  }

  // Labels de máquinas
  scheduler.templates.timeline_scale_label = function (key, label) {
    return `<div style="line-height:42px;padding:0 8px">${label}</div>`
  }

  // Texto dentro de eventos
  scheduler.templates.event_text = function (start, end, ev) {
    const tipo = ev.tipo || 'Actividad'
    let texto = ev.text || tipo
    if (ev.cliente) texto += ` · ${ev.cliente}`
    return texto
  }

  // Clases CSS por tipo de evento
  scheduler.templates.event_class = function (start, end, ev) {
    const tipo = ev.tipo || 'Actividad'
    let cls = ''

    switch (tipo) {
      case 'Transición':
        cls = 'type-Transicion'
        break
      case 'Arranque':
      case 'Arrancada':
        cls = 'type-Arranque'
        break
      case 'NoDisponibleCalendario':
      case 'NoDisponible':
        cls = 'type-NoDisponible'
        break
      case 'Ocupada':
        cls = 'type-Ocupada'
        break
      default:
        cls = 'type-Actividad'
        break
    }

    // Añadir clase de retraso si aplica
    if (ev.retraso && tipo === 'Actividad') {
      cls += ' delayed'
    }

    return cls
  }
}
